<template>
  <div class="popup" v-if="showType == 1">
    <div class="masktop"></div>
    <div class="mask">
      <div class="show">
        <!-- <a class="link"
          ><img class="showimg" @click="postfn" :src="close_pic"
        /></a> -->
        <a class="link" @click="gotoPath"
          ><img :src="image" class="show-img"
        /></a>
      </div>
    </div>
  </div>
  <div class="popup" v-else-if="showType == 2">
    <div class="masktop1" @click="postfn"></div>
    <div class="mask1">
      <div class="show1">
        <a class="link"
          ><img class="showimg1" @click="postfn" :src="close_pic"
        /></a>
        <a class="link" @click="gotoPath"
          ><img :src="image" class="show-img1"
        /></a>
      </div>
    </div>
  </div>
  <div class="popup" v-else>
    <div class="masktop2" @click="postfn"></div>
    <div class="mask2">
      <div class="show2">
        <a class="link"
          ><img class="showimg2" @click="postfn" :src="close_pic"
        /></a>
        <a class="link" @click="gotoPath"
          ><img :src="image" class="show-img2"
        /></a>
      </div>
    </div>
  </div>
</template>

<script>
import countdown from "@/components/tempcount/countdown.vue";
import { getNewUser, getToken } from "../../utils/storage";
export default {
  components: {
    countdown,
  },
  data() {
    return {
      image: require("@/assets/images/pp_postnew.png"),
      close_pic: require("@/assets/images/ad_close.png"),
      isNewUser: false,
      showType: 1,
      info: {
        currentTime: new Date(),
        startDate: new Date(1635782400000),
        endDate: new Date(1636646400000),
        isFlag: false, //是否显示
      },
    };
  },
  mounted() {
    this.getImagePath();
  },
  methods: {
    //定义方法
    postfn() {
      //向父组件发射xxx事件
      if (this.$store.state.common.userInfo.gender != 1) {
        this.$store.commit("updateShowPost", false);
      }
      //this.$store.commit("updateShowPost", false);
    },
    gotoPath() {

      let routeUrl =
          "https://pp.qqtuku.com/login?loginAuthKey=" +
          getToken() +
          "&type=" +
          this.$store.state.user.loginNameType;
        //   let routeUrl =
        //   "https://pp.qqtuku.com/login"
        window.open(routeUrl, "_self");
    },
    getImagePath() {
      //是否迁移用户---是否律师---是否新用户---是否普通用户
      this.isNewUser = JSON.parse(getNewUser());
      this.image = require("@/assets/images/pp_postnew.png");

      if (this.$store.state.common.userInfo.gender == 1) {
        this.image = require("@/assets/images/pp_postnew.png");
        this.showType = 1;
      }
      // } else if (this.$store.state.common.userInfo.gender == 2) {
      //   this.image = "";
      //   this.$store.commit("updateShowPost", false);
      // } else {
      //   if (
      //     this.$store.state.common.userInfo.blance !== null &&
      //     this.$store.state.common.userInfo.blance > 0
      //   ) {
      //     this.showType = 3;
      //     this.image = require("@/assets/images/postnew.png");
      //   } else {
      //     if (this.isNewUser) {
      //       this.showType = 2;
      //       this.image = require("@/assets/images/userpop.png");
      //     } else {
      //       this.showType = 3;
      //       this.image = require("@/assets/images/postnew.png");
      //     }
      //   }
      // }
      //this.image = require("@/assets/images/postnew.png");

      // if (this.$store.state.common.userInfo.gender == 1) {
      //   this.isNewUser = true;
      //   this.image = require("@/assets/images/message_post.png");
      // } else {
      //   this.isNewUser = false;
      //   this.image =
      //     "https://pp.sviptuku.com/baseFrame2/api/search/image/postnew1.png";
      // }
    },
  },
};
</script>

<style scoped>
@keyframes rotate {
  0% {
    transform: rotateY(0deg);
  }
  100% {
    transform: rotateY(360deg);
  }
}
.popup {
  z-index: 10000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all 0.5s;
}

.masktop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #000000;
  height: 100%;
  opacity: 0.5;
}

.mask {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0);
  z-index: 1002;
}

.mask .show {
  text-align: center;
  margin: auto;
  background-color: transparent;
}

.show-img {
  width: 536px;
  height: 640px;
  margin: auto;
  object-fit: fill;
}

.mask .show .showimg {
  position: absolute;
  right: -50px;
  top: -30px;
  width: 50px;
}

.masktop1 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000000;
  opacity: 0.5;
}

.mask1 {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0);
  z-index: 1002;
}

.mask1 .show1 {
  text-align: center;
  margin: auto;
  background-color: transparent;
}
.show-img1 {
  width: 460px;
  height: 560px;
  margin: auto;
  object-fit: fill;
}
.mask1 .show1 .showimg1 {
  position: absolute;
  right: -30px;
  top: -20px;
  width: 50px;
}

.mask .show .showtime {
  position: absolute;
  left: 50%;
  top: 72%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  color: #fff;
}

.masktop2 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000000;
  opacity: 0.5;
}

.mask2 {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0);
  z-index: 1002;
}

.mask2 .show2 {
  text-align: center;
  margin: auto;
  background-color: transparent;
}

.show-img2 {
  width: 720px;
  height: 320px;
  margin: auto;
  object-fit: fill;
}

.mask2 .show2 .showimg2 {
  position: absolute;
  right: -50px;
  top: -30px;
  width: 50px;
}

.link:hover,
.server-table i.el-tooltip:hover {
  cursor: pointer;
  color: #409eff;
}
</style>
